module.exports = __webpack_public_path__ + "static/media/covid_banner_mobile.e4e72dc1.jpg";